import React, { useState, useEffect, useRef } from "react";

import { Order } from "./order";

import "./style.css";
import { getOrders } from "../../api/kd";
import { addIdKeyIfMissing } from "@delibrandev/utils/src/function.js";

export const KitchenDisplay = () => {
  const reCallInMs = 10000;
  const [orders, setOrders] = useState([]);
  const [queryError, setQueryError] = useState(false);
  const [queryPending, setQueryPending] = useState(false);
  const queryInFlight = useRef(false);

  const query = async () => {
    const payload = {
      page: 0,
      pageSize: 1000,
      orderStatus: "pending",
      sortOrder: "ASC",
    };
    if (queryInFlight.current) return;
    queryInFlight.current = true;
    setQueryPending(true);
    try {
      const response = await getOrders(payload);
      if (response?.error !== false || !Array.isArray(response.data?.orders)) throw new Error("Orders unavailable");
      const ordersUpdated = addIdKeyIfMissing(
        response.data.orders
          .filter(order => !["prepared", "inDelivery", "delivered"].includes(order.status))
          .slice().reverse(),
      );
      setOrders(ordersUpdated);
      setQueryError(false);
    } catch {
      setQueryError(true);
    } finally {
      queryInFlight.current = false;
      setQueryPending(false);
    }
  };

  useEffect(() => {
    query();
    const interval = setInterval(() => {
      query();
    }, reCallInMs);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!queryPending && !queryError && orders.length === 0 && <p role="status">No hay pedidos pendientes en este gestor.</p>}
      {queryError && <div role="alert">
        No hemos podido actualizar los pedidos. Las acciones quedan bloqueadas hasta recuperar la conexión.
        <button type="button" onClick={query} disabled={queryPending} style={{ minHeight: "44px" }}>
          {queryPending ? "Actualizando…" : "Reintentar"}
        </button>
      </div>}
      <fieldset aria-busy={queryPending} disabled={queryError} style={{ border: 0, padding: 0, margin: 0, minInlineSize: 0 }}>
        <div className="kitchen-display">
        {orders &&
          orders.length > 0 &&
          orders.map((order) => (
            <div key={order.orderId} className="order">
              <Order data={order} updateOrders={query} />
            </div>
          ))}
        </div>
      </fieldset>
    </>
  );
};
